module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/userPrivacy-banner.876947cc.png";